<template>
  <div class="aside-tools">
    <div class="aside-tools-label">
      <aside-item-icon
        :icon="icon"
        :updateMark="updateMark"
      />
      <span>{{ label }}</span>
    </div>
    <a
      v-if="hasCloseButton"
      class="aside-close"
      :class="{'is-hidden-desktop':isMainMenu}"
      @click="close"
    >
      <b-icon
        icon="close"
        custom-size="default"
      />
    </a>
  </div>
</template>

<script>
import AsideItemIcon from "@/components/theme/AsideItemIcon";
export default {
  name: "AsideTools",
  components: {
    AsideItemIcon
  },
  props: {
    icon: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    updateMark: {
      type: String,
      default: null
    },
    isMainMenu: {
      type: Boolean,
      default: false
    },
    hasCloseEvent: {
      type: Boolean,
      default: false
    },
    hasCloseButton: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    close() {
      if (this.hasCloseEvent) {
        this.$emit("close-click");
      } else {
        this.$jbUtils.overlayHide();
      }
    }
  }
};
</script>